// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";

function RecordActionModal(Props) {
  var modalComponent = Props.modalComponent;
  var onClose = Props.onClose;
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(onClose, undefined);
                }),
              overlayClassName: "porter-form__modal-overlay",
              className: "porter-form__modal porter-form__modal-size-70",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: modalComponent
            });
}

var make = RecordActionModal;

export {
  make ,
  
}
/* react Not a pure module */
